import { render, staticRenderFns } from "./AdmisionGenerarButaca.vue?vue&type=template&id=63641da8"
import script from "./AdmisionGenerarButaca.vue?vue&type=script&lang=js"
export * from "./AdmisionGenerarButaca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports